<template>
    <div class="h-100">
        <div v-if="$web.isDesktop" class="desktop">
            <div class="row">

                <div class="col-md-8 py-5 pr-5">
                    <h1 class="desktop-title text-left">
                        Benvenuto sull'App online di LiRe.
                    </h1>

                    <p class="lead">
                        Grazie alla nostra Applicazione scopri in pochi click quanto puoi ridurre i consumi Energetici
                        dei tuoi clienti!
                    </p>

                    <p>
                        Segui i passi del check-up energetico di LiRe: il sistema di calcolo ti restituirà in pochi
                        secondi una prima analisi del margine di miglioramento possibile in termini di risparmio
                        energetico ed economico.
                    </p>

                    <p>
                        Ma non solo, hai anche la possibilità di ottenere una prima consulenza
                        <strong>A COSTO ZERO</strong>, con uno degli esperti di gestione energetica di Lire.
                    </p>

                    <p class="lead">
                        Perchè A COSTO ZERO?
                    </p>

                    <p>
                        Perchè siamo una giovane start-up - dotata di altissime professionalità nell’ambito delle
                        diagnosi energetiche e della progettazione per l'efficienza energetica - e, per dimostrarti la
                        bontà del nostro operato, abbiamo deciso di offrire ai primi utilizzatori della nostra
                        applicazione un primo consulto, senza chiedere un solo euro in cambio.
                    </p>

                    <p class="lead">ATTENZIONE, noi NON vendiamo forniture!</p>

                    <p>
                        Noi di Lire NON vendiamo forniture di Luce o Gas e NON ti proporremo contratti con fornitori
                        alternativi: la nostra missione è AIUTARTI A RISPARMIARE sui tuoi consumi, il che non significa
                        per forza cambiare fornitore.
                    </p>

                    <div class="next-step-suggestion">
                        <img :src="icon('tap-icon')" alt="Clicca per continuare">
                        <h2>Scegli una fornitura per iniziare</h2>
                        <h2 class="next-step-arrow blink">→</h2>
                    </div>
                </div>

                <div class="col-md-4 mt-5">
                    <!-- Electric  -->
                    <ImageBtn
                        class="mb-5"
                        :large="true"
                        :value="ELECTRIC_ENERGY"
                        @click="selectVectorType"
                        :text="contents.ee"
                        :src="icon('ee-icon')"/>

                    <!-- Gas -->
                    <ImageBtn
                        :large="true"
                        :value="GAS"
                        @click="selectVectorType"
                        :text="contents.gas"
                        :src="icon('gas-icon')"/>
                </div>
            </div>
        </div>
        <BottomBg v-else>

            <!-- Logo -->
            <TopLogo/>

            <!-- Text -->
            <p v-text="contents.select" class="select-label"/>

            <!-- Electric  -->
            <ImageBtn
                :large="true"
                :value="ELECTRIC_ENERGY"
                @click="selectVectorType"
                :text="contents.ee"
                :src="icon('ee-icon')"/>

            <!-- Gas -->
            <ImageBtn
                :large="true"
                :value="GAS"
                @click="selectVectorType"
                :text="contents.gas"
                :src="icon('gas-icon')"/>

        </BottomBg>
    </div>
</template>

<script>
import contents from "../contents/vectors"
import ImageBtn from "../components/ImageBtn";
import TopLogo from "../components/TopLogo";
import BottomBg from "../components/BottomBg";
import {ELECTRIC_ENERGY, GAS, types} from "@/data/profile"

export default {
    name: 'profile-types',
    components: {ImageBtn, TopLogo, BottomBg},
    mounted() {
        this.$registerEvent('Pagina', '2. Selezione vettore');
    },
    data() {
        return {
            title: 'Profile types',
            types,
            contents,
            ELECTRIC_ENERGY,
            GAS
        };
    },
    methods: {
        selectVectorType(vector) {
            this.$store.commit('setProfileVector', vector);
            this.$router.push('/types');
        },
        icon(icon) {
            return require(`../assets/icons/${icon}.svg`);
        }
    }
};
</script>

<style lang="scss" scoped>
.select-label {
    font-weight: bold;
    text-align: center;
    padding: 0 40px;
    margin-bottom: 40px;
    font-size: 18px;
    color: #121212;
}

.col-6 {
    padding: 0 10px;
}

.btn-icon {
    margin-bottom: 15px;
}

.desktop {
    h1 {
        margin-bottom: 22px;
    }

    p {
        font-family: "Open Sans";
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 22px;
        color: #FFFFFF;

        &.lead {
            font-size: 1.25rem;
            font-weight: 300;
        }
    }
}

@keyframes blink {
    0% {
        opacity: 0
    }
    20% {
        opacity: 1
    }
    80% {
        opacity: 1
    }
    100% {
        opacity: 0
    }
}

.blink {
    -webkit-animation: blink 2s linear infinite;
    -moz-animation: blink 2s linear infinite;
    animation: blink 2s linear infinite;
}

.next-step-suggestion {
    display: flex;
    padding: 20px;
    color: #fff;
    margin-top: 40px;
    background: rgba(255, 255, 255, 0.1);
    justify-content: space-evenly;
    box-shadow: 0 10px 10px rgba(0, 0, 0, 0.05);

    img {
        width: 60px;
    }

    h2 {
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: 0 10px;
        font-size: 22px;
        margin-bottom: 0;
    }

    .next-step-arrow {
        font-size: 36px;
    }
}
</style>
